import { Box, List, ListItem, Text } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import type { DocumentCategory, ViewDocumentAsOwnerDto } from "../../../../../../autogen/bff-api";
import { useDocumentCategoryLabel } from "../../../../../../common/documents/useDocumentCategoryLabel";

interface DocumentCategoryGroupProps {
  category: DocumentCategory;
  documents: ViewDocumentAsOwnerDto[];
}

export const DocumentCategoryGroup = ({ category, documents }: DocumentCategoryGroupProps) => {
  const { t } = useTranslation();
  const label = useDocumentCategoryLabel();

  return (
    <Box mb="3">
      <Text
        fontSize="xs"
        textTransform="uppercase"
        letterSpacing="wider"
        color="smMuted"
        mb="1"
      >
        {label(category)}
      </Text>
      {documents.length === 0 ? (
        <Text as="em" fontSize="sm" color="smMuted" fontStyle="italic">
          {t("No documents")}
        </Text>
      ) : (
        <List spacing="1" pl="0" styleType="none">
          {documents.map((doc) => (
            <ListItem key={doc.id} fontSize="sm" fontWeight="medium">
              {doc.name}
            </ListItem>
          ))}
        </List>
      )}
    </Box>
  );
};
